import { createFileRoute } from "@tanstack/react-router";
import { DEFAULT_COMPANY, isCompanyId } from "../prototype/fixtures";
import { BankingScreen } from "../screens/BankingScreen";

export const Route = createFileRoute("/prototype/c/$companyId/banking/")({
  component: BankAccounts,
});

function BankAccounts() {
  const { companyId } = Route.useParams();
  return <BankingScreen companyId={isCompanyId(companyId) ? companyId : DEFAULT_COMPANY} />;
}
